import Vue from 'vue';
import { BfSpinner } from "components/Butterfly";
import UserTypeSelect from 'src/components/account/UserList/UserTypeSelect.vue';
import InviteUserModal from 'src/components/account/UserList/InviteUserModal.vue';
import Site from 'src/api/site';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    name: 'SiteUsersList',
    components: { BfSpinner, UserTypeSelect, InviteUserModal },
    props: {
        showInviteModal: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            error: undefined,
            invitations: [],
        };
    },
    mounted() {
        this.fetchInvitationData();
    },
    methods: {
        date(val) {
            return `Sent ${FormatUtils.date(val)}`;
        },
        async fetchInvitationData() {
            this.loading = true;
            try {
                this.invitations = await this._fetch();
            }
            catch (e) {
                this.error = 'Unable to fetch invitation data';
            }
            finally {
                this.loading = false;
            }
        },
        _fetch() {
            return Site.getMembershipInvitations();
        },
        async deleteInvitation(inviteId) {
            this.loading = true;
            try {
                await Site.deleteInvitation(inviteId);
            }
            finally {
                try {
                    this.fetchInvitationData();
                }
                finally {
                    this.loading = false;
                }
            }
        },
        handleModalClose($event) {
            this.$emit('close', $event);
            this.fetchInvitationData();
        },
        handleInvited(email) {
            this.$notify({
                title: 'Invited!',
                dangerouslyUseHTMLString: true,
                message: `We have sent the invitation to<br />${email}`,
                type: 'success'
            });
            this.fetchInvitationData();
        }
    },
});
